export default __webpack_public_path__ + "static/media/Web 1280 ΓÇô 63.fb03d3fe.jpg";